import React, { useRef, useState } from "react";
import { Text, TextInput, Pressable, View, StyleSheet } from "react-native";
import ActionSheet, { ActionSheetRef } from "react-native-actions-sheet";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Picker } from "@react-native-picker/picker";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import useTimeTracking from "../../hooks/TimeTracking/useTimeTracking"; // ajusta la ruta si es distinta
import { Platform } from "react-native";
import dayjs from "dayjs";

export type RequestEntrySheetRef = {
  show: (type: string, time: Date, id?:number, comment?: string) => void;
};

type Props = {
  onSubmit: (data: { type: string; time: string; id?:number, comment?: string }) => void;
};


const RequestEntrySheet = React.forwardRef<RequestEntrySheetRef, Props>(
  ({ onSubmit }, ref) => {
    const actionSheetRef = useRef<ActionSheetRef>(null);

    const [selectedType, setSelectedType] = useState("");
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedHour, setSelectedHour] = useState("12");
    const [selectedMinute, setSelectedMinute] = useState("00");
    const [selectedPeriod, setSelectedPeriod] = useState("AM");
    const [comment, setComment] = useState("");
    const [id, setId] = useState<number | undefined>(undefined);
    React.useImperativeHandle(ref, () => ({
      show: (type, time, id, initialComment) => {
        const parsed = time ? dayjs(time) : dayjs();
        setSelectedType(type || "");
        setSelectedDate(parsed);
        setSelectedHour(parsed.format("hh"));
        setSelectedMinute(parsed.format("mm"));
        setSelectedPeriod(parsed.format("A"));
        setId(id);
        // setComment(initialComment || "");
        actionSheetRef.current?.show();
      },
    }));

    // const handleSubmit = () => {
    //   if (!selectedType) return;

    //   const fullDate = selectedDate
    //     .hour(
    //       (parseInt(selectedHour) % 12) + (selectedPeriod === "PM" ? 12 : 0)
    //     )
    //     .minute(parseInt(selectedMinute));

    //   onSubmit({
    //     type: selectedType,
    //     time: fullDate.format("YYYY-MM-DD HH:mm"),
    //     comment: comment.trim() || undefined,
    //   });

    //   actionSheetRef.current?.hide();
    // };
    const { requestEntry } = useTimeTracking();
    const handleSubmit = async () => {
      if (!selectedType) return;
    
      const fullDate = selectedDate
        .hour((parseInt(selectedHour) % 12) + (selectedPeriod === "PM" ? 12 : 0))
        .minute(parseInt(selectedMinute));
    
      try {
        console.log("📤 Submitting request payload:", {
          type: selectedType,
          time: fullDate.toISOString(),
          comment: comment.trim(),
        });
    
        await requestEntry(
          selectedType as "ClockIn" | "ClockOut" | "BreakIn" | "BreakOut" | "LunchIn" | "LunchOut",
          fullDate.toISOString(),
          id
          
        );
        actionSheetRef.current?.hide();
        console.log("✅ Request submitted successfully.");
        actionSheetRef.current?.hide();
      } catch (error) {
        console.error("❌ Error submitting request:", error);
      }
    };

    const hours = Array.from({ length: 12 }, (_, i) =>
      String(i + 1).padStart(2, "0")
    );
    const minutes = Array.from({ length: 60 }, (_, i) =>
      String(i).padStart(2, "0")
    );

    return (
      <ActionSheet ref={actionSheetRef} containerStyle={styles.sheet}>
        <Text style={styles.title}>Time Tracker Request</Text>

        <Text style={styles.label}>Entry Type</Text>
        <Picker
          selectedValue={selectedType}
          onValueChange={setSelectedType}
          style={styles.picker}
        >
          <Picker.Item label="Select Type" value="" />
          <Picker.Item label="Clock In" value="ClockIn" />
          <Picker.Item label="Clock Out" value="ClockOut" />
          <Picker.Item label="Break In" value="BreakIn" />
          <Picker.Item label="Break Out" value="BreakOut" />
          <Picker.Item label="Lunch In" value="LunchIn" />
          <Picker.Item label="Lunch Out" value="LunchOut" />
        </Picker>

        <Text style={styles.label}>Select Date</Text>
        <View style={{ marginBottom: 20 }}>
          <DatePicker
            label="Edit date"
            value={selectedDate}
            onChange={(val) => val && setSelectedDate(val)}
            slotProps={{
              textField: {
                variant: "outlined",
                size: "small",
                fullWidth: true,
              },
              popper: {
                disablePortal: true,
              },
            }}
          />
        </View>

        <Text style={styles.label}>Select Time</Text>
        <View style={{ flexDirection: "row", marginBottom: 20 }}>
          <Picker
            selectedValue={selectedHour}
            onValueChange={setSelectedHour}
            style={styles.picker}
          >
            {hours.map((h) => (
              <Picker.Item key={h} label={h} value={h} />
            ))}
          </Picker>
          <Picker
            selectedValue={selectedMinute}
            onValueChange={setSelectedMinute}
            style={styles.picker}
          >
            {minutes.map((m) => (
              <Picker.Item key={m} label={m} value={m} />
            ))}
          </Picker>
          <Picker
            selectedValue={selectedPeriod}
            onValueChange={setSelectedPeriod}
            style={styles.picker}
          >
            <Picker.Item label="AM" value="AM" />
            <Picker.Item label="PM" value="PM" />
          </Picker>
        </View>

        <Text style={styles.label}>Comment (optional)</Text>
        {Platform.OS === "web" ? (
          <TextareaAutosize
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Add details about the correction..."
            style={{
              width: "100%",
              padding: 12,
              fontSize: 15,
              borderRadius: 10,
              borderColor: "#d1d5db",
              borderWidth: 1,
              marginBottom: 24, // 👈 aquí agregamos margen inferior
            }}
          />
        ) : (
          <TextInput
            value={comment}
            onChangeText={setComment}
            placeholder="Add details about the correction..."
            multiline
            style={styles.textArea}
          />
        )}

        <Pressable style={styles.submitBtn} onPress={handleSubmit}>
          <Text style={styles.submitText}>Submit</Text>
        </Pressable>
      </ActionSheet>
    );
  }
);

const styles = StyleSheet.create({
  sheet: {
    padding: 20,
    backgroundColor: "#fff",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: "700",
    textAlign: "center",
    color: "#1f2937",
    marginBottom: 24,
  },
  label: {
    fontSize: 14,
    fontWeight: "500",
    color: "#374151",
    marginBottom: 6,
  },
  picker: {
    height: 50,
    width: "100%",
    marginBottom: 20,
    borderWidth: 1,
    borderColor: "#d1d5db",
    borderRadius: 4,
  },
  textArea: {
    height: 100,
    borderWidth: 1,
    borderColor: "#d1d5db",
    borderRadius: 10,
    padding: 12,
    textAlignVertical: "top",
    fontSize: 15,
    color: "#111827",
    marginBottom: 24,
  },
  submitBtn: {
    backgroundColor: "#10B981",
    paddingVertical: 14,
    borderRadius: 10,
  },
  submitText: {
    textAlign: "center",
    fontWeight: "600",
    fontSize: 16,
    color: "white",
  },
});

export default RequestEntrySheet;
